module.exports = __webpack_public_path__ + "img/Business-verification-API.491a1e4f.png";